export default __webpack_public_path__ + "static/media/GM.12b76aba.png";